declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, DoctorsListController, DoctorsListRequest, SaveExternalDoctorInfoRequest, ExternalDoctorsListController, ExternalDoctorsListRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { Providerlistpipe, Externallistpipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'custsearchprovider',
  templateUrl: './custsearchprovider.modal.html',
  styleUrls: ['./custsearchprovider.modal.scss']
})

export class NgbCustSearchProviderModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() IsShowDoctor: boolean = false;
  @Input() IsShowNurse: boolean = false;
  @Input() IsShowProvieded: boolean = false;
  @Input() DoctorType: string;
  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;
  CurrentSaveExternalDoctorInfoRequest: SaveExternalDoctorInfoRequest;


  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  DocFriendlyName: string = "";
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.pdata = this.CurrentDoctorsListController;

    if (this.DoctorType == "DOC") {
      this.CurrentDoctorsListRequest.ConditionalOperator = 40
    }
    else if (this.DoctorType == "STAFF") {
      this.CurrentDoctorsListRequest.ConditionalOperator = 60
    }
    else if (this.DoctorType == "All") {
      this.CurrentDoctorsListRequest.ConditionalOperator = 20
    }
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.pdata = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);
          this.LoadExDoctorsList();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentExternalDoctorsListController: ExternalDoctorsListController[];
  CurrentExternalDoctorsListRequest: ExternalDoctorsListRequest;

  LoadExDoctorsList() {
    this.CurrentExternalDoctorsListController = new Array<ExternalDoctorsListController>();

    this.CurrentExternalDoctorsListRequest = new ExternalDoctorsListRequest();

    this.pdata2 = this.CurrentExternalDoctorsListController;
    this.CurrentExternalDoctorsListRequest.DoctorCode = 0;
    this.CurrentExternalDoctorsListRequest.ConditionalOperator = 10;
    this.CurrentExternalDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetExternalDoctorsListController();
  }
  GetExternalDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetExternalDoctorsListController(this.CurrentExternalDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentExternalDoctorsListController = this.ApiResData.Result;
          this.pdata2 = this.CurrentExternalDoctorsListController;
          //this.pdata = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  RefreshPatients(st: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = st;

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  _GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = null;
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }




  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number = 0;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter, private filter: Providerlistpipe, private spinner: NgxSpinnerService, private filter2: Externallistpipe) { }
  ngOnInit() {

    //this.LoadPatients();

    this.LoadDoctorsList();

    this.CurrentSaveExternalDoctorInfoRequest = new SaveExternalDoctorInfoRequest();
    this.CurrentSaveExternalDoctorInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }
  onSubmitExternal() {
    this.spinner.show();
    this.CurrentSaveExternalDoctorInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveExternalDoctorInfoRequest.Salutation = "Dr.";
    this.CurrentSaveExternalDoctorInfoRequest.IsReferralDoctor = true;
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveExternalDoctorInfo(this.CurrentSaveExternalDoctorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          if (this.ApiResData.Result > 0) {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.LoadExDoctorsList();
            this.Clear();
            //this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            // this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            // this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }

  Clear() {
    this.CurrentSaveExternalDoctorInfoRequest.DoctorName = "";
    this.CurrentSaveExternalDoctorInfoRequest.DoctorInstitute = "";
    this.CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo = "";
    this.CurrentSaveExternalDoctorInfoRequest.Location = "";
  }

  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentDoctorsListController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentDoctorsListController,
          this.listFilter);
      }
    }
  }
  pdata2: any[];// = this.data;
  listFilter2: string;
  ngOnChanges2(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata2 = this.CurrentExternalDoctorsListController;

    this.criteriaChange2(this.listFilter2);
  }
  criteriaChange2(value: any) {
    if (this.filter2 != null) {
      if (value != '[object Event]') {
        this.listFilter2 = value;
        //alert(this.listFilter);
        this.pdata2 = this.filter2.transform(this.CurrentExternalDoctorsListController,
          this.listFilter2);
      }
    }
  }
  //criteriaChange(value: string) {
  //  this.RefreshPatients(value);


  //}
  Doctorname: string;
  providercode: number;
  NurseName: string;
  Nursecode: number;
  NurseNumber: string;
  ProvidedName: string;
  Providedcode: number;
  Providernumber: string;
  Providerdesg: string;
  Institute: string;
  ProviderDetails(l: DoctorsListController) {
    this.Doctorname = l.DisplayName;
    this.providercode = l.ProviderCode;
    this.Providernumber = l.Telephone1;
    this.Providerdesg = l.Specialty;
    //this.passEntry.emit(this.Doctorname);
    //this.passEntry.emit(this.providercode);
    this.passEntry.emit({ make: this.Doctorname, value: this.providercode, number: this.Providernumber, desg: this.Providerdesg });
    this.activeModal.dismiss('Cross click');
  }
  ProviderDetails2(l: ExternalDoctorsListController) {
    this.Doctorname = l.DisplayName;
    this.providercode = l.DocCode;
    this.Providernumber = l.Telephone1;
    this.Institute = l.ClinicName;
    //this.passEntry.emit(this.Doctorname);
    //this.passEntry.emit(this.providercode);
    this.passEntry.emit({ make: this.Doctorname, value: this.providercode, number: this.Providernumber, Institute: this.Institute });
    this.activeModal.dismiss('Cross click');
  }
  NurseDetails(l: DoctorsListController) {
    this.NurseName = l.DisplayName;
    this.Nursecode = l.ProviderCode;
    this.NurseNumber = l.Telephone1;
    //this.passEntry.emit(this.Doctorname);
    //this.passEntry.emit(this.providercode);
    this.passEntry.emit({ make: this.NurseName, value: this.Nursecode, number: this.NurseNumber });
    this.activeModal.dismiss('Cross click');
  }
  ProvidedDetails(l: DoctorsListController) {
    this.ProvidedName = l.DisplayName;
    this.Providedcode = l.ProviderCode;
    this.Providernumber = l.Telephone1;
    this.Providerdesg = l.Specialty;
    //this.passEntry.emit(this.Doctorname);
    //this.passEntry.emit(this.providercode);
    this.passEntry.emit({ make: this.ProvidedName, value: this.Providedcode, number: this.Providernumber, desg: this.Providerdesg });
    this.activeModal.dismiss('Cross click');
  }

  SelectedPatientDetails: PatientInfoByFormattedCodeController;

  SelectedPatient(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;
    if (patient != null) {

      //this.router.navigate(['testnurse/serviceconfig']);
      this.SelectedPatientDetails = patient;

      this.activeModal.dismiss;
      //alert(document[0].ActorDocPageCode);
      //let options: NgbModalOptions = {
      //  size: 'lg',
      //  centered: true
      //};
      //const modalRef = this.modalService.open(NgbDocumentModal, options)
      //modalRef.componentInstance.DocFriendlyName = document.DocFriendlyName;
      //modalRef.componentInstance.DocTitle = document.DocTitle;
      //modalRef.componentInstance.DocCaptureDate = document.DocCaptureDate;
      //modalRef.componentInstance.ActorDocPageCode = document.ActorDocPageCode;

    }
    else {

    }
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}



  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

